import { HStack, IconButton, Stack, Text } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useMemo } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import styled from "styled-components";
import { Icon } from "../../components/Icon";
import { useStores } from "../../hooks/useStores";
import { VimeoVideo } from "../../types";
import ReactGA from "react-ga";

interface RouteParams {
  categoryExternalId: string;
}

export const ClientVideo: React.FC = observer(() => {
  const { categoryExternalId } = useParams<RouteParams>();
  const { session } = useStores();
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    if (categoryExternalId) {
      // ReactGA.pageview(`/client/video-categories/${categoryExternalId}`);
      session.getVideoList(categoryExternalId);
    }
  }, [categoryExternalId, session]);

  const videoCategory = useMemo(() => {
    return session.videoCategories.find(
      (category) => category.externalId === categoryExternalId
    );
  }, [categoryExternalId, session]);

  return (
    <Stack margin={"2rem"} gridGap={"2rem"}>
      <Stack marginBottom={"2rem"}>
        <Text fontSize="3xl">{t("screens.client.customer.onlineTraning")}</Text>
        <HStack>
          <IconButton
            aria-label="Back"
            icon={<Icon iconName={"HiArrowLeft"} />}
            variant={"ghost"}
            onClick={() => history.push("/client/video-categories")}
          />
          <Text fontSize="xl" fontWeight={300}>
            {videoCategory?.name}
          </Text>
        </HStack>
      </Stack>

      <HStack justifyContent={"center"} gridGap={"2rem"} flexWrap={"wrap"}>
        {session.videoList.map((video) => (
          <VideoCard
            key={video.link}
            video={video}
            onClick={() =>
              history.push(
                `/client/video-categories/${categoryExternalId}/video/${video.resourceKey}`
              )
            }
          />
        ))}
      </HStack>
    </Stack>
  );
});

export const toHHMMSS = (seconds: number) =>
  new Date(seconds * 1000).toISOString().substr(11, 8);

type Props = {
  video: VimeoVideo;
  onClick: () => void;
};

const VideoCard: React.FC<Props> = ({ video, onClick }) => {
  return (
    <Stack w={"270px"} cursor={"pointer"} onClick={onClick}>
      <Stack position={"relative"}>
        <VideoThumb src={video.picture} />
        <ThumbnailTime>{toHHMMSS(video.duration)}</ThumbnailTime>
      </Stack>
      <Text>{video.name}</Text>
    </Stack>
  );
};

const VideoThumb = styled.img`
  width: 270px;
  height: 150px;
`;

const ThumbnailTime = styled.span`
  position: absolute;
  bottom: 4px;
  right: 4px;
  color: #fff;
  background-color: #000000cc;
  padding: 3px 4px;
  border-radius: 2px;
  font-size: 12px;
`;
